import { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { useAuth } from './AuthProvider'

const AuthRoute = ({ children }) => {
  const { loading, isAuthenticated, loginWithRedirect } = useAuth()
  const location = useLocation()

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      loginWithRedirect({
        appState: { targetUrl: location.pathname + location.search }
      })
    }
  }, [loading, isAuthenticated, loginWithRedirect, location])

  if (loading) {
    return null
  }
  if (!isAuthenticated) {
    return null
  }

  return children
}

AuthRoute.propTypes = {
  children: PropTypes.node.isRequired,
}

export default AuthRoute
